import { render, staticRenderFns } from "./LoginShaderBackground.vue?vue&type=template&id=0472bc14&scoped=true"
import script from "./LoginShaderBackground.vue?vue&type=script&lang=js"
export * from "./LoginShaderBackground.vue?vue&type=script&lang=js"
import style0 from "./LoginShaderBackground.vue?vue&type=style&index=0&id=0472bc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472bc14",
  null
  
)

export default component.exports